import React from 'react';
import { useStyles } from './styles';
import { MenuItem, Menu } from '@material-ui/core';
import FilterDramaIcon from '@material-ui/icons/FilterDrama';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';

export const ReinventButton = () => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openMsg, setOpenMsg] = React.useState(false);

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleClose2 = (reason: any) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenMsg(false);
  };
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  return (
    <div className={classes.MenuIcon}>
      <a className={classes.buttonCustom} onClick={handleClick}>
        <FilterDramaIcon className={classes.filterIcon} /> AWS Re:Invent 2025
      </a>
      <ReinventMenuOption
        anchorEl={anchorEl}
        handleClose={handleClose}
        setOpenMsg={setOpenMsg}
      />
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        className={classes.alerts}
        open={openMsg}
        autoHideDuration={5000}
        onClose={handleClose2}
      >
        <Alert onClose={handleClose2} severity={'info'}>
          <div className={classes.alertHeader}> Discount code copied</div>
        </Alert>
      </Snackbar>
    </div>
  );
};

export const ReinventMenuOption = ({
  anchorEl,
  handleClose,
  setOpenMsg,
}: any) => {
  return (
    <Menu
      id="simple-menu"
      anchorEl={anchorEl}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      keepMounted
      open={Boolean(anchorEl)}
      onClose={handleClose}
      //style={{width:'80% !important'}}
    >
      <MenuItem
        onClick={() => {
          navigator.clipboard.writeText('SALAWALXXNPk');
          setOpenMsg(true);
        }}
        style={{ color: 'black',whiteSpace:'break-spaces'}}
      >
        <strong>Save $150 On Registration:</strong>{' '}
        <span style={{ fontStyle: 'italic' }}> Use code SALAWALXXNPk and save $150 off their registration. </span>
      </MenuItem>
      <MenuItem style={{whiteSpace:'break-spaces'}}>
        <div>
          <strong>Group Ticket Offers.</strong> Buy 10 registrations, get 1 full conference pass free. <br/>This includes the $150 off discounted price of $1,949 each. This offer is available while supplies last.
        </div>
      </MenuItem>
      <MenuItem style={{whiteSpace:'break-spaces'}}> 
        <a
          href="https://reinvent.awsevents.com/?trk=direct"
          onClick={handleClose}
          target="_blank"
        >
          <strong>Registration link:</strong> https://reinvent.awsevents.com/?trk=direct
        </a>
      </MenuItem>
    </Menu>
  );
};
